import { MailboxInfo } from 'owa-client-ids';
import RequestOptions from 'owa-service/lib/RequestOptions';

export default function getMailboxRequestOptions(
    mailboxInfo?: MailboxInfo,
    requestOptions?: RequestOptions
): MailboxRequestOptions | RequestOptions {
    if (mailboxInfo) {
        return {
            mailboxInfo: mailboxInfo,
            ...requestOptions,
        } as MailboxRequestOptions;
    } else {
        return requestOptions;
    }
}

/**
 * MailboxRequestOptions is used to intercept requests within owa-service
 * and add appropriate headers for different scenarios like Connected Accounts,
 * Explicit logon etc.
 */
interface MailboxRequestOptions extends RequestOptions {
    /**
     * The mailbox information needed to route the request to the correct mailbox
     * by adding the appropriate headers
     */
    mailboxInfo: MailboxInfo;
}
